import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: [],
  bankCompany: [],
  paymentSetting: [],
};
const paymentSlice = createSlice({
  name: "payment",
  initialState,
  reducers: {
    setBankCompany: (state, action) => {
      state.bankCompany = action.payload;
    },
    setPaymentSetting: (state, action) => {
      state.paymentSetting = action.payload;
    },
    clearBankCompany: (state) => {
      state.bankCompany = [];
    },
    clearPaymentSetting: (state) => {
      state.paymentSetting = [];
    },
  },
});
export const { setBankCompany, clearBankCompany, setPaymentSetting, clearPaymentSetting } = paymentSlice.actions;
export default paymentSlice.reducer;
